import ServerConfigFilesViewer from "@/components/server-config-files-viewer"
import type { NginxConfig, Server } from "@/types"

interface NginxConfigsPageProps {
  server: Pick<Server, "id" | "name" | "hostname">
  configs: NginxConfig[]
}

export default function NginxConfigsPage({
  server,
  configs,
}: NginxConfigsPageProps) {
  return (
    <ServerConfigFilesViewer
      server={server}
      configs={configs}
      pageTitle="Nginx Configs"
      headingTitle="Nginx Configuration Files"
      directoryPath="/etc/nginx/sites-available/ and /etc/nginx/sites-enabled/"
      breadcrumbTitle="Nginx Configs"
    />
  )
}
